export default "__VITE_ASSET__ce5e1237__"